/**
 * LanguageSwitcher.jsx — Drop-in <select> for changing UI language.
 * Sits in the topbar of the authenticated dashboard AND on PublicSignup.
 */
import React from 'react';
import { Languages } from 'lucide-react';
import { useI18n } from './I18nContext.jsx';

export default function LanguageSwitcher({ compact = false, style = {} }) {
  const { lang, setLang, locales } = useI18n();
  return (
    <label
      data-testid="language-switcher-wrap"
      title="Language"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 6,
        padding: compact ? '4px 8px' : '6px 10px',
        borderRadius: 8,
        border: '1px solid var(--border, rgba(148,163,184,0.3))',
        background: 'var(--surface-3, rgba(255,255,255,0.05))',
        cursor: 'pointer',
        ...style,
      }}
    >
      <Languages size={compact ? 12 : 14} aria-hidden="true" />
      <select
        data-testid="language-switcher-select"
        value={lang}
        onChange={e => setLang(e.target.value)}
        aria-label="Language"
        style={{
          background: 'transparent', color: 'inherit',
          border: 0, outline: 'none', cursor: 'pointer',
          fontSize: compact ? 11 : 12, fontWeight: 600,
        }}
      >
        {locales.map(l => (
          <option key={l.code} value={l.code} style={{ background: '#0f172a', color: '#f1f5f9' }}>
            {l.label}
          </option>
        ))}
      </select>
    </label>
  );
}
